import React from "react";
import PropTypes from "prop-types";
import { includes } from "ramda";
import { connect } from "react-redux";
import List from "@mui/material/List";
import { goToPage } from "~/store/middlewares/page";
import { selectDisplayedPages } from "~/store/selectors/page";
import { selectBookmarksSorted } from "~/store/ducks/user/bookmarks";
import { selectAspectRatio } from "~/store/ducks/domain/config";
import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";
import { closeSidebarLeft } from "~/store/ducks/user/uistate";
import { absolutePageToRelative } from "~/utils";
import SinglePagePreview from "./SinglePagePreview";

function Bookmark({ page, pages, onNodeClick, label, aspectRatio }) {
  const isSelected = includes(page, pages);

  function onItemClick() {
    onNodeClick(page);
  }

  return (
    <SinglePagePreview
      page={page}
      label={label}
      isActive={isSelected}
      onClick={onItemClick}
      aspectRatio={aspectRatio}
    />
  );
}

Bookmark.propTypes = {
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pages: PropTypes.array,
  onNodeClick: PropTypes.func,
  label: PropTypes.string,
  aspectRatio: PropTypes.number
};

function BookmarkList({
  bookmarks,
  pages,
  onNodeClick,
  className,
  aspectRatio,
  isGreaterThanMedium,
  closeSidebarLeft
}) {
  function onClick(page) {
    onNodeClick(page);

    if (!isGreaterThanMedium) {
      closeSidebarLeft();
    }
  }

  return (
    <List className={className} disablePadding>
      {bookmarks.map(bookmark => (
        <Bookmark
          key={bookmark._id}
          onNodeClick={onClick}
          pages={pages}
          page={bookmark.page}
          label={`Seite ${absolutePageToRelative(bookmark.page)}`}
          aspectRatio={aspectRatio}
        />
      ))}
    </List>
  );
}

BookmarkList.propTypes = {
  bookmarks: PropTypes.array,
  pages: PropTypes.array,
  onNodeClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  aspectRatio: PropTypes.number,
  isGreaterThanMedium: PropTypes.bool.isRequired,
  closeSidebarLeft: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    bookmarks: selectBookmarksSorted(state),
    pages: selectDisplayedPages(state),
    aspectRatio: selectAspectRatio(state),
    isGreaterThanMedium: selectIsGreaterThanMedium(state)
  };
}

const mapDispatchToProps = {
  onNodeClick: goToPage,
  closeSidebarLeft
};

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkList);
